export default __webpack_public_path__ + "static/media/2DShape_03.6f0ac59b.png";